import ajax from "../../lib/appfuse-react/core/ajax";

const registrationService = {
    validate: async (data) => {
        await ajax.post('registrations/validate', data);
    },
    sendVerificationCode: async (email) => {
        const response = await ajax.get(`registrations/sendVerificationCode/${email}`);
        return response.ok;
    },
    confirmVerificationCode: async (email, token) => {
        const response = await ajax.get(`registrations/confirmVerificationCode/${email}/${token}`);
        return response.ok;
    },
    complete: async (data) => {
        await ajax.post('registrations', data);
    }
}

export default registrationService;